export default {
  name: 'SettingFinancialPaypal',

  props: {
    form: {
      paypalEmail: String,
      confirmPaypalEmail: String
    },
    disabled: Boolean
  },

  methods: {
    emitFormChange: function() {
      this.$emit('paypal-info', this.form);
    }
  }
};
